import { Grid, ContextMenu, ContextMenuTrigger, ContextMenuContent } from '@cad-arc';
import React from 'react';
import { Components } from 'react-virtuoso';
import { QueueHeaderRow } from './queue-header-row';
import { StickyGroupHeader } from './sticky-group-header';
import { ContextMenuQueueContent } from './context-menu-queue-content';
import { handleCloseAutoFocus } from '../../context-menus/on-close-auto-focus';
import { useContextMenuStateWrite } from '../context/use-context-menu-state';
import { debounce } from 'lodash';

export const QueueVirtuosoListWrapper: Components['List'] = React.forwardRef(
    function QueueVirtuosoListWrapper({ children, style, ...rest }, ref) {
        const contextMenuStateWrite = useContextMenuStateWrite();
        const onOpenChange = React.useMemo(
            // Debouncing `onOpenChange` is important because when users right click on two rows
            // in succession withnout closing the context menu, `onOpenChange` will report `false` at first and then `true` again.
            // Without debouncing, we will wipe the context menu state which we set in response to the user right-clicking.
            // We only want to wipe state if the context menu actually got fully closed and no other menu has been opened.
            () => debounce((open: boolean) => !open && contextMenuStateWrite(undefined), 10),
            [contextMenuStateWrite]
        );
        // hacky way to determine if we are rendering the list or the sticky group headers
        if (rest['data-test-id'] === 'virtuoso-top-item-list') {
            return (
                <StickyGroupHeader style={style} ref={ref} {...rest}>
                    {children}
                </StickyGroupHeader>
            );
        }
        return (
            <QueueHeaderRow>
                <ContextMenu isModal={true} onOpenChange={onOpenChange}>
                    <ContextMenuTrigger asChild>
                        <Grid
                            data-testid="queue-body"
                            // this opts us out of the browser's default behavior of minimizing content shifts.
                            // in our queues we want content to shift when the list is being sorted
                            style={{ ...style, overflowAnchor: 'none' }}
                            ref={ref}
                            {...rest}
                        >
                            {children}
                        </Grid>
                    </ContextMenuTrigger>
                    <ContextMenuContent
                        onCloseAutoFocus={handleCloseAutoFocus}
                        style={{ maxHeight: '600px' }}
                    >
                        <ContextMenuQueueContent />
                    </ContextMenuContent>
                </ContextMenu>
            </QueueHeaderRow>
        );
    }
);
